import { AxiosError } from 'axios';
import { toast } from 'react-toastify';

/**
 * Sends an error message to a Slack channel.
 *
 * @param {string} error - The error message.
 * @param {string} url - The URL where the error occurred.
 * @param {string} endpoint - The endpoint where the error occurred.
 */

/** */
const getAmbientVariable = () => {
  if (['production'].includes(process.env.REACT_APP_ENV as string)) {
    return process.env.REACT_APP_WEBHOOK_SLACK_PRODUCTION;
  }
  return process.env.REACT_APP_WEBHOOK_SLACK_STAGING;
};

export const sendError = async (error: any, url: string, endpoint: string) => {
  try {
    console.log(error);
    if (error.response.status !== 404) {
      const currentDate = new Date();
      const currentDateString = currentDate.toLocaleDateString();
      const currentTimeString = currentDate.toLocaleTimeString();
      const agencyName = localStorage.getItem('agencyName') || 'Não informado';
      const userName = localStorage.getItem('userName') || 'Não informado';

      const webhookEndpoint = getAmbientVariable() || '';
      const msg = {
        channel: 'log-erros-agencias',
        text:
          `⚡ ATENÇÃO ⚡\n` +
          `❌ *Erro:* ${
            error.response?.data?.errors?.errorDetails || error.response?.data?.title || error.response.data.error
          }\n` +
          `🏬 *Agência:* ${agencyName}\n` +
          `🧔 *Usuário:* ${userName}\n` +
          `📅 *Data:* ${currentDateString}\n` +
          `⏲ *Hora:* ${currentTimeString}\n` +
          `🔗 *Url:* ${url}\n` +
          `💫 *Endpoint:* ${endpoint}\n`,
      };

      fetch(webhookEndpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(msg),
      })
        .then((res) => {})
        .catch((err) => {
          toast.error('Houve um erro ao enviar o log para o slack');
        });
    }
  } catch (err) {
    console.log(err);
  }
};
